export const blockIconsCommunicationSentimentSatisfiedAlt = (
	<span className='material-symbols-outlined'>sentiment_satisfied_alt</span>
);
